export type SupportedLocale = "en" | "fr" | "ja" | "es";

const supportedLocales: SupportedLocale[] = ["en", "fr", "ja", "es"];

export function resolveSupportedLocale(locale: string | null | undefined): SupportedLocale {
  if (!locale) return "en";
  const language = locale.trim().toLowerCase().replace("_", "-").split("-")[0];
  return supportedLocales.find((supportedLocale) => supportedLocale === language) ?? "en";
}

export function getDeviceLocale(): SupportedLocale {
  if (typeof navigator === "undefined") return "en";
  const preferredLocale = navigator.languages?.[0] ?? navigator.language;
  return resolveSupportedLocale(preferredLocale);
}
